import React, { useState } from 'react';
import { IoMdArrowBack } from "react-icons/io";
import './Enrollment.css';
import { useNavigate } from "react-router-dom";
import { TbPhotoUp } from "react-icons/tb";

const KycPage = () => {
  const [fileName, setFileName] = useState("No file chosen");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const navigate = useNavigate();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileName(file ? file.name : "No file chosen");
  };

  const goToPage = () => {
    navigate("/enrollment_form");
    return
  };    
  return (
    <>
      {/* <div className="header">
        <h3 className="header-title">KYC Details</h3>
      </div> */}

      {/* <div className="form-container2">
        <div className="form-box2">
          <h3 className="header-title">Basic Details</h3>
          <br />
          <div className="input-group">
            <input className="input-field" placeholder="Mobile Number Linked with Aadhaar*" />
            <input className="input-field" placeholder="Aadhaar Number*" />
            <div className="file-upload">
              <input 
                type="file" 
                id="fileInput1" 
                className="file-input" 
                onChange={handleFileChange} 
              />
              <label htmlFor="fileInput1" className="file-label">
              Aadhaar Front Image
              </label>
              <TbPhotoUp style={{fontSize:"30px", color:"white"}}/>
            </div>

            <div className="file-upload">
              <input 
                type="file" 
                id="fileInput2" 
                className="file-input" 
                onChange={handleFileChange} 
              />
              <label htmlFor="fileInput2" className="file-label">
              Aadhaar Back Image
              </label>
              <TbPhotoUp style={{fontSize:"30px", color:"white"}}/>
            </div>

            <input className="input-field" placeholder="PAN Number*" />
            
            <div className="file-upload">
              <input 
                type="file" 
                id="fileInput2" 
                className="file-input" 
                onChange={handleFileChange} 
              />
              <label htmlFor="fileInput2" className="file-label">
              PAN Image
              </label>
              <TbPhotoUp style={{fontSize:"30px", color:"white"}}/>
            </div>

            <div className='btn-section'>
            <button className='btn-class2' onClick={goToPage}>Skip KYC</button>
            <button className='btn-class2' onClick={goToPage}>Submit</button>
            </div>

          </div>
        </div>
      </div> */}
    </>
  )
}

export default KycPage